import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	forgeFieldErrorTextLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	forgeFieldSuccessTextLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	forgeFieldPendingTextLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	forgeFieldErrorTextLabel: {
		id: 'forge-field-base.form.field-message.forge-field-error-text-label',
		defaultMessage: "We couldn't save the value of this custom field.",
		description:
			'Message shown on the description of Forge field when request to get field value failed.',
	},
	forgeFieldSuccessTextLabel: {
		id: 'forge-field-base.form.field-message.forge-field-success-text-label',
		defaultMessage: 'Custom field value saved.',
		description:
			'Message shown on the description of Forge field when request to get field value succeed.',
	},
	forgeFieldPendingTextLabel: {
		id: 'forge-field-base.form.field-message.forge-field-pending-text-label',
		defaultMessage: 'Saving custom field value.',
		description: 'Message shown on the description of Forge field when request is pending.',
	},
});
export default messages;
